import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

export const RegionCodeSelectOption = (props: OptionProps<TOption>) => {
  const isLast = (props.options[props.options.length - 1] as TOption).value === props.data.value;
  return (
    <components.Option {...props}>
      <div className="pt-4 pb-8">
        <div className="flexbox">
          <Text size="medium">{props.data.label}</Text>
        </div>
        <Text type="secondary" size="medium">{props.data.meta as string}</Text>
      </div>
      {!isLast && <Divider isHorizontal type="primary" color="light"/>}
    </components.Option>
  );
};
